import { mapGetters, mapState, mapActions } from 'vuex';

export default {
  props: {
    hideDelay: {
      type: Number,
      default: 300,
    },
  },
  data() {
    return {
      isVisible: false,
      hideTimeout: null,
      watchdogTimeout: null,
    };
  },
  computed: {
    ...mapState('app', ['newLoaderCounter']),
    ...mapGetters('app', ['newLoaderIsLoading']),
  },
  watch: {
    newLoaderIsLoading: {
      handler: 'newLoaderIsLoadingHandler',
      immediate: true,
    },
  },
  beforeDestroy() {
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
    }
    if (this.watchdogTimeout) {
      clearTimeout(this.watchdogTimeout);
    }
  },
  methods: {
    ...mapActions('app', ['resetLoaderCounter']),
    newLoaderIsLoadingHandler(value) {
      if (value) {
        this.showLoader();
      } else {
        this.hideLoader();
      }
    },
    showLoader() {
      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout);
      }
      if (this.watchdogTimeout) {
        clearTimeout(this.watchdogTimeout);
      }
      this.watchdogTimeout = setTimeout(() => {
        this.resetLoaderCounter();
      }, 5000);
      this.isVisible = true;
    },
    hideLoader() {
      if (this.watchdogTimeout) {
        clearTimeout(this.watchdogTimeout);
      }
      this.hideTimeout = setTimeout(() => {
        this.isVisible = false;
      }, this.hideDelay);
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/app/app-loader/app-loader.js